/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { NotificationEmail } from './NotificationEmail';
import {
    NotificationEmailFromJSON,
    NotificationEmailFromJSONTyped,
    NotificationEmailToJSON,
    NotificationEmailToJSONTyped,
} from './NotificationEmail';
import type { NotificationEmailCreate } from './NotificationEmailCreate';
import {
    NotificationEmailCreateFromJSON,
    NotificationEmailCreateFromJSONTyped,
    NotificationEmailCreateToJSON,
    NotificationEmailCreateToJSONTyped,
} from './NotificationEmailCreate';

/**
 * 
 * @export
 * @interface SettingUpdate
 */
export interface SettingUpdate {
    /**
     * 
     * @type {string}
     * @memberof SettingUpdate
     */
    preOpsMessage?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SettingUpdate
     */
    preOpsHoursUntilRecheck?: number | null;
    /**
     * 
     * @type {Array<NotificationEmail>}
     * @memberof SettingUpdate
     */
    preOpsNotificationEmails?: Array<NotificationEmail> | null;
    /**
     * 
     * @type {Array<NotificationEmailCreate>}
     * @memberof SettingUpdate
     */
    preOpsNotificationEmailsCreate?: Array<NotificationEmailCreate> | null;
    /**
     * 
     * @type {boolean}
     * @memberof SettingUpdate
     */
    preOpsRecheckOnDriverChange?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof SettingUpdate
     */
    impactMessage?: string | null;
    /**
     * 
     * @type {Array<NotificationEmail>}
     * @memberof SettingUpdate
     */
    impactNotificationEmails?: Array<NotificationEmail> | null;
    /**
     * 
     * @type {Array<NotificationEmailCreate>}
     * @memberof SettingUpdate
     */
    impactNotificationEmailsCreate?: Array<NotificationEmailCreate> | null;
    /**
     * 
     * @type {Array<NotificationEmail>}
     * @memberof SettingUpdate
     */
    maintenanceNotificationEmails?: Array<NotificationEmail> | null;
    /**
     * 
     * @type {Array<NotificationEmailCreate>}
     * @memberof SettingUpdate
     */
    maintenanceNotificationEmailsCreate?: Array<NotificationEmailCreate> | null;
    /**
     * 
     * @type {boolean}
     * @memberof SettingUpdate
     */
    generateDemoData?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof SettingUpdate
     */
    openidConnectClientId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SettingUpdate
     */
    openidConnectClientSecret?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SettingUpdate
     */
    openidConnectIssuerUrl?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SettingUpdate
     */
    universalPin?: string | null;
}

/**
 * Check if a given object implements the SettingUpdate interface.
 */
export function instanceOfSettingUpdate(value: object): value is SettingUpdate {
    return true;
}

export function SettingUpdateFromJSON(json: any): SettingUpdate {
    return SettingUpdateFromJSONTyped(json, false);
}

export function SettingUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): SettingUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'preOpsMessage': json['preOpsMessage'] == null ? undefined : json['preOpsMessage'],
        'preOpsHoursUntilRecheck': json['preOpsHoursUntilRecheck'] == null ? undefined : json['preOpsHoursUntilRecheck'],
        'preOpsNotificationEmails': json['preOpsNotificationEmails'] == null ? undefined : ((json['preOpsNotificationEmails'] as Array<any>).map(NotificationEmailFromJSON)),
        'preOpsNotificationEmailsCreate': json['preOpsNotificationEmailsCreate'] == null ? undefined : ((json['preOpsNotificationEmailsCreate'] as Array<any>).map(NotificationEmailCreateFromJSON)),
        'preOpsRecheckOnDriverChange': json['preOpsRecheckOnDriverChange'] == null ? undefined : json['preOpsRecheckOnDriverChange'],
        'impactMessage': json['impactMessage'] == null ? undefined : json['impactMessage'],
        'impactNotificationEmails': json['impactNotificationEmails'] == null ? undefined : ((json['impactNotificationEmails'] as Array<any>).map(NotificationEmailFromJSON)),
        'impactNotificationEmailsCreate': json['impactNotificationEmailsCreate'] == null ? undefined : ((json['impactNotificationEmailsCreate'] as Array<any>).map(NotificationEmailCreateFromJSON)),
        'maintenanceNotificationEmails': json['maintenanceNotificationEmails'] == null ? undefined : ((json['maintenanceNotificationEmails'] as Array<any>).map(NotificationEmailFromJSON)),
        'maintenanceNotificationEmailsCreate': json['maintenanceNotificationEmailsCreate'] == null ? undefined : ((json['maintenanceNotificationEmailsCreate'] as Array<any>).map(NotificationEmailCreateFromJSON)),
        'generateDemoData': json['generateDemoData'] == null ? undefined : json['generateDemoData'],
        'openidConnectClientId': json['openidConnectClientId'] == null ? undefined : json['openidConnectClientId'],
        'openidConnectClientSecret': json['openidConnectClientSecret'] == null ? undefined : json['openidConnectClientSecret'],
        'openidConnectIssuerUrl': json['openidConnectIssuerUrl'] == null ? undefined : json['openidConnectIssuerUrl'],
        'universalPin': json['universalPin'] == null ? undefined : json['universalPin'],
    };
}

export function SettingUpdateToJSON(json: any): SettingUpdate {
    return SettingUpdateToJSONTyped(json, false);
}

export function SettingUpdateToJSONTyped(value?: SettingUpdate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'preOpsMessage': value['preOpsMessage'],
        'preOpsHoursUntilRecheck': value['preOpsHoursUntilRecheck'],
        'preOpsNotificationEmails': value['preOpsNotificationEmails'] == null ? undefined : ((value['preOpsNotificationEmails'] as Array<any>).map(NotificationEmailToJSON)),
        'preOpsNotificationEmailsCreate': value['preOpsNotificationEmailsCreate'] == null ? undefined : ((value['preOpsNotificationEmailsCreate'] as Array<any>).map(NotificationEmailCreateToJSON)),
        'preOpsRecheckOnDriverChange': value['preOpsRecheckOnDriverChange'],
        'impactMessage': value['impactMessage'],
        'impactNotificationEmails': value['impactNotificationEmails'] == null ? undefined : ((value['impactNotificationEmails'] as Array<any>).map(NotificationEmailToJSON)),
        'impactNotificationEmailsCreate': value['impactNotificationEmailsCreate'] == null ? undefined : ((value['impactNotificationEmailsCreate'] as Array<any>).map(NotificationEmailCreateToJSON)),
        'maintenanceNotificationEmails': value['maintenanceNotificationEmails'] == null ? undefined : ((value['maintenanceNotificationEmails'] as Array<any>).map(NotificationEmailToJSON)),
        'maintenanceNotificationEmailsCreate': value['maintenanceNotificationEmailsCreate'] == null ? undefined : ((value['maintenanceNotificationEmailsCreate'] as Array<any>).map(NotificationEmailCreateToJSON)),
        'generateDemoData': value['generateDemoData'],
        'openidConnectClientId': value['openidConnectClientId'],
        'openidConnectClientSecret': value['openidConnectClientSecret'],
        'openidConnectIssuerUrl': value['openidConnectIssuerUrl'],
        'universalPin': value['universalPin'],
    };
}

